import apollo from 'graphql/apollo';
import { changePasswordMutation } from 'graphql/mutations';

const changePassword = async ({ newPassword, currentPassword }) =>
  apollo.mutate({
    mutation: changePasswordMutation,
    variables: { newPassword, currentPassword },
  });
export default changePassword;
